<div
    class="root"
    [class.loaded]="loaded"
    [class.unloaded]="!loaded"
    [class.selected]="selected$ | async"
    [class.inspected]="inspected$ | async"
>
    <div class="asset-type" [style.border-color]="AssetColorMap.get(asset.asset_type)">
        @if (asset.asset_type !== AssetType.Image) {
            <mat-icon>{{ IconMap.get(asset.asset_type) }}</mat-icon>
        }
    </div>

    <div class="grad"></div>

    <frog-badge [asset]="asset" />

    @if (selectionMode$ | async) {
        @if ({ isSelected: selected$ | async }; as context) {
            <div (click)="selectAsset(context.isSelected)">
                <img src="{{ thumbnail }}" (error)="loadError()" />
            </div>
        }
    } @else {
        @if (streamId$ | async; as streamId) {
            <a [routerLink]="getLink(streamId)" [queryParams]="queryParams$ | async">
                <img src="{{ thumbnail }}" (error)="loadError()" />
            </a>
        } @else {
            <a [routerLink]="getLink()" [queryParams]="queryParams$ | async">
                <img src="{{ thumbnail }}" (error)="loadError()" />
            </a>
        }
    }

    <div class="thumbnail-details">
        <div>
            <p (click)="inspect()" class="truncate">
                {{ asset.name }}
            </p>
            <small (click)="filterByUser()" class="author primary desktop"
                >{{ asset.author.name | titlecase }}
                <span class="created">{{ asset.created | dateAgo }} </span></small
            >
        </div>
        <img src="{{ asset.author.email | identicon | async }}" class="user-icon" />
    </div>
</div>
